export default class CompactImage {
  constructor(parent) {
    console.assert(typeof parent.width === 'number' && typeof parent.height === 'number');
    this._parent = parent;
    this._offsetX = 0;
    this._offsetY = 0;
    this._image = CompactImage._ZERO_IMAGE;
  }
  static _ZERO_IMAGE = {
    data: {
      length: 0,
    },
    width: 0,
    height: 0,
  };
  get _width() { return this._parent.width; }
  get _height() { return this._parent.height; }
  // CompactImageの深いコピーを返す
  clone() {
    const clone = new CompactImage(this._parent);
    clone._offsetX = this._offsetX;
    clone._offsetY = this._offsetY;
    if(this._image !== CompactImage._ZERO_IMAGE) {
      clone._image = new ImageData(this._image.width, this._image.height);
      clone._image.data.set(this._image.data);
    }
    return clone;
  }
  createImageData() {
    const image = new ImageData(this._width, this._height);
    if(this._image !== CompactImage._ZERO_IMAGE) {
      for(let y = 0; y < this._image.height; ++y) {
        const srcIdx = (y * this._image.width) * 4;
        const dstIdx = ((y + this._offsetY) * image.width + this._offsetX) * 4;
        const src = this._image.data.slice(srcIdx, srcIdx + this._image.width * 4);
        image.data.set(src, dstIdx);
      }
    }
    return image;
  }
  putImageData(ctx) {
    ctx.clearRect(0, 0, this._width,  this._height);
    if(this._image !== CompactImage._ZERO_IMAGE) {
      ctx.putImageData(this._image, this._offsetX, this._offsetY);
    }
  }
  getAsOffscreenCanvas() {
    const canvas = new OffscreenCanvas(this._width, this._height);
    if(this._image !== CompactImage._ZERO_IMAGE) {
      canvas.getContext('2d').putImageData(this._image, this._offsetX, this._offsetY);
    }
    return canvas;
  }
  /*addUsedColorToSet(set, ignoreAlpha) {
    const arr = new Uint32Array(this._image.data.buffer);
    const shift = ignoreAlpha ? 8 : 0;
    for(let i = 0; i < arr.length; ++i) {
      const value = arr[i] >> shift;
      set.add(value);
    }
  }*/
  _get4Corner(image, startX, startY, width, height) {
    let x1 = image.width;
    let y1 = image.height;
    let x2 = -1;
    let y2 = -1;
    for(let y = startY; y < startY + height; ++y) {
      for(let x = startX; x < startX + width; ++x) {
        const i = (y * image.width + x) * 4;
        if(image.data[i + 3]) {
          if(x < x1) x1 = x;
          if(y < y1) y1 = y;
          if(x2 < x) x2 = x;
          if(y2 < y) y2 = y;
        }
      }
    }
    return [x1, y1, x2, y2, x1 <= x2 && y1 <= y2];
  }
  setImageData(image) {
    console.assert(image.width === this._width && image.height === this._height);
    const [x1, y1, x2, y2, flag] = this._get4Corner(image, 0, 0, image.width, image.height);
    if(flag) {
      console.assert(x1 <= x2 && y1 <= y2);
      const width = x2 - x1 + 1;
      const height = y2 - y1 + 1;
      this._offsetX = x1;
      this._offsetY = y1;
      this._image = new ImageData(width, height);
      for(let y = y1; y <= y2; ++y) {
        const srcIdx = (y * image.width + x1) * 4;
        const dstIdx = ((y - y1) * this._image.width) * 4;
        const src = image.data.slice(srcIdx, srcIdx + width * 4);
        this._image.data.set(src, dstIdx);
      }
    } else {
      this._offsetX = 0;
      this._offsetY = 0;
      this._image = CompactImage._ZERO_IMAGE;
    }
  }
  // 引数のx,yは親座標基準
  getPixel(x, y) {
    if(
      this._offsetX <= x && x < this._offsetX + this._image.width &&
      this._offsetY <= y && y < this._offsetY + this._image.height
    ) {
      const i = ((y - this._offsetY) * this._image.width + (x - this._offsetX)) * 4;
      return this._image.data.slice(i, i + 4);
    } else if(0 <= x && x < this._width && 0 <= y && y < this._height) {
      return Uint8ClampedArray.from([0, 0, 0, 0]);
    } else {
      throw new RangeError();
    }
  }
  getPixelIdx(idx) {
    const x = (idx / 4) % this._width;
    const y = Math.floor((idx / 4) / this._width);
    return this.getPixel(x, y);
  }
  byteSize() {
    return this._image.data.length
  }
  merge(...others) {
    const ctx = new OffscreenCanvas(this._width, this._height).getContext('2d');
    others.push(this);
    for(let i = others.length - 1; 0 <= i; --i) {
      const o = others[i];
      if(o._image !== CompactImage._ZERO_IMAGE) {
        const ctx2 = new OffscreenCanvas(o._image.width, o._image.height).getContext('2d');
        ctx2.putImageData(o._image, 0, 0);
        ctx.drawImage(ctx2.canvas, o._offsetX, o._offsetY);
      }
    }
    this.setImageData(ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height));
  }

  resize(x1, y1, x2, y2) {
    /*
    (x,y)が示す4つの座標について解説
    旧親座標：リサイズ前の_parent._image上の座標
    旧子座標：リサイズ前の_image上の座標
    新親座標：リサイズ後の_parent._image上の座標
    新子座標：リサイズ後の_image上の座標
  
    旧子座標←(±_offsetX/Y)→旧親座標←(±引数x1/y1)→新親座標←(±newOffsetX/Y)→新子座標
    */
    console.assert(x1 <= x2 && y1 <= y2);
    let newWidth = this._image.width;
    let newHeight = this._image.height;
    let newOffsetX = this._offsetX - x1;
    let newOffsetY = this._offsetY - y1;
    {
      const cx1 = this._offsetX;
      const cy1 = this._offsetY;
      const cx2 = cx1 + this._image.width - 1;
      const cy2 = cy1 + this._image.height - 1;
      if(cx1 < x1) newWidth -= x1 - cx1, newOffsetX = 0;
      if(x2 < cx2) newWidth -= cx2 - x2;
      if(cy1 < y1) newHeight -= y1 - cy1, newOffsetY = 0;
      if(y2 < cy2) newHeight -= cy2 - y2;
    }
    if(newWidth !== this._image.width || newHeight !== this._image.height) {
      const undo = {
        offsetX: this._offsetX,
        offsetY: this._offsetY,
        image: this._image,
        byteSize: this.byteSize(),
      };
      {
        const gapX = newOffsetX + x1 - this._offsetX;  // 新子座標(0,0)を旧子座標に変換
        const gapY = newOffsetY + y1 - this._offsetY;
        //console.log('引数：', gapX, gapY, newWidth, newHeight);
        const [crx1, cry1, crx2, cry2, flag] = this._get4Corner(this._image, gapX, gapY, newWidth, newHeight);
        //console.log('戻値：', crx1, cry1, crx2, cry2, flag)
        if(flag) {
          newOffsetX = crx1 - x1 + this._offsetX;  // 旧子座標(crx1,cry1)を新親座標に変換
          newOffsetY = cry1 - y1 + this._offsetY;
          newWidth = crx2 - crx1 + 1;
          newHeight = cry2 - cry1 + 1;
        } else {
          this._image = CompactImage._ZERO_IMAGE;
          this._offsetX = 0;
          this._offsetY = 0;
          return undo;
        }
      }
      const newImage = new ImageData(newWidth, newHeight);
      const gapX = newOffsetX + x1 - this._offsetX;  // 新子座標(x,y)を旧子座標に変換するための値
      const gapY = newOffsetY + y1 - this._offsetY;
      for(let y = 0; y < newImage.height; ++y) {
        const newIdx = (y * newImage.width) * 4;
        const oldIdx = ((y + gapY) * this._image.width + gapX) * 4;
        const src = this._image.data.slice(oldIdx, oldIdx + newWidth * 4);
        newImage.data.set(src, newIdx);
      }
      this._image = newImage;
      this._offsetX = newOffsetX;
      this._offsetY = newOffsetY;
      return undo;
    } else {
      const undo = {
        offsetX: this._offsetX,
        offsetY: this._offsetY,
        image: null,
        byteSize: 0,
      };
      this._offsetX = newOffsetX;
      this._offsetY = newOffsetY;
      return undo;
    }
  }
  undoResize(params) {
    this._offsetX = params.offsetX;
    this._offsetY = params.offsetY;
    if(params.image) this._image = params.image;
  }
}
